import { render, staticRenderFns } from "./VerificationPhoneNumber.vue?vue&type=template&id=5de8c1c0&scoped=true&"
import script from "./VerificationPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./VerificationPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./VerificationPhoneNumber.vue?vue&type=style&index=0&id=5de8c1c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de8c1c0",
  null
  
)

export default component.exports